let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'
export { urlAlphabet }



//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoid/url-alphabet/index.js
// module id = null
// module chunks = 